import React, { useState } from "react";
import LogoCEA from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import SyncLoader from "react-spinners/SyncLoader";

const HEARD_OPTIONS = ["CEN", "Care Group", "Social Media", "Others"];

const RegisterGraduation = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [churchOption, setChurchOption] = useState("");
  const [churchOther, setChurchOther] = useState("");
  const [heardFrom, setHeardFrom] = useState("");
  const [heardOther, setHeardOther] = useState("");
  const [willAttend, setWillAttend] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const churchName = churchOption === "Others" ? churchOther.trim() : churchOption;
    const heardValue = heardFrom === "Others" ? `Others: ${heardOther.trim()}` : heardFrom;

    if (!fullName || !email || !phone || !churchOption || !heardFrom || !willAttend) {
      Swal.fire({ text: "Please fill all required fields.", icon: "warning", background: "white", color: "black", confirmButtonColor: "#fb3104" });
      return;
    }
    if (churchOption === "Others" && !churchOther.trim()) {
      Swal.fire({ text: "Please enter your local church name.", icon: "warning", background: "white", color: "black", confirmButtonColor: "#fb3104" });
      return;
    }
    if (heardFrom === "Others" && !heardOther.trim()) {
      Swal.fire({ text: "Please specify how you heard about Cutting Edge Academy.", icon: "warning", background: "white", color: "black", confirmButtonColor: "#fb3104" });
      return;
    }

    setIsLoading(true);
    try {
      await axios.post("/specialregistration", {
        type: "graduation",
        name: fullName,
        email,
        phoneNumber: phone,
        localChurch: churchName,
        city: heardValue,
        message: `Will attend onsite: ${willAttend}`,
      });
      Swal.fire({
        title: "Registration Submitted!",
        text: "Thank you for registering. We will contact you soon.",
        icon: "success",
        background: "white",
        color: "black",
        confirmButtonColor: "#fb3104",
        confirmButtonText: "OK",
      }).then(() => navigate("/"));
    } catch (err) {
      Swal.fire({ text: err.response?.data?.msg || "Something went wrong.", icon: "error", background: "white", color: "black", confirmButtonColor: "#fb3104" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f4f4f4", display: "flex", justifyContent: "center", alignItems: "center", padding: "40px 16px" }}>
      {isLoading && (
        <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(255,255,255,0.8)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}>
          <SyncLoader color="#fb3104" />
        </div>
      )}
      <div style={{ backgroundColor: "#fff", borderRadius: "12px", padding: "40px", width: "100%", maxWidth: "520px", boxShadow: "0 4px 16px rgba(0,0,0,0.1)" }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <img src={LogoCEA} alt="CEA Logo" style={{ width: "64px", height: "64px", objectFit: "contain", marginBottom: "12px" }} />
          <h4 style={{ fontWeight: "700", color: "#fb3104", marginBottom: "4px" }}>GRADUATION (PUBLIC)</h4>
          <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>Cutting Edge Academy</p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Full Name */}
          <div className="mb-3">
            <label className="form-label">Full Name <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="text" className="form-control" value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Your full name" />
          </div>

          {/* Email */}
          <div className="mb-3">
            <label className="form-label">Email <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="example@email.com" />
          </div>

          {/* WhatsApp */}
          <div className="mb-3">
            <label className="form-label">WhatsApp Number <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="text" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))} placeholder="628xxxxxxxxx" />
          </div>

          {/* Church Name */}
          <div className="mb-3">
            <label className="form-label">Church Name <span style={{ color: "#fb3104" }}>*</span></label>
            <select
              className="form-control"
              value={churchOption}
              onChange={(e) => { setChurchOption(e.target.value); setChurchOther(""); }}
            >
              <option value="">Select church...</option>
              <option value="IFGF Bandung">IFGF Bandung</option>
              <option value="Others">Others</option>
            </select>
            {churchOption === "Others" && (
              <input
                type="text"
                className="form-control mt-2"
                value={churchOther}
                onChange={(e) => setChurchOther(e.target.value)}
                placeholder="Enter your local church name"
              />
            )}
          </div>

          {/* How did you hear */}
          <div className="mb-3">
            <label className="form-label">
              How did you hear about Cutting Edge Academy? <span style={{ color: "#fb3104" }}>*</span>
            </label>
            {HEARD_OPTIONS.map((opt) => (
              <div className="form-check" key={opt}>
                <input
                  className="form-check-input"
                  type="radio"
                  id={`heard-${opt}`}
                  name="heardFrom"
                  value={opt}
                  checked={heardFrom === opt}
                  onChange={() => { setHeardFrom(opt); setHeardOther(""); }}
                  style={{ width: "13px", height: "13px", marginTop: "3px", cursor: "pointer" }}
                />
                <label className="form-check-label" htmlFor={`heard-${opt}`} style={{ fontSize: "14px" }}>{opt}</label>
              </div>
            ))}
            {heardFrom === "Others" && (
              <input
                type="text"
                className="form-control mt-2"
                value={heardOther}
                onChange={(e) => setHeardOther(e.target.value)}
                placeholder="Please specify..."
              />
            )}
          </div>

          {/* Will attend */}
          <div className="mb-4">
            <label className="form-label">
              Will you attend the graduation ceremony onsite at 10 AM, The House Bandung? <span style={{ color: "#fb3104" }}>*</span>
            </label>
            {["Yes", "No"].map((opt) => (
              <div className="form-check" key={opt}>
                <input
                  className="form-check-input"
                  type="radio"
                  id={`attend-${opt}`}
                  name="willAttend"
                  value={opt}
                  checked={willAttend === opt}
                  onChange={() => setWillAttend(opt)}
                  style={{ width: "13px", height: "13px", marginTop: "3px", cursor: "pointer" }}
                />
                <label className="form-check-label" htmlFor={`attend-${opt}`} style={{ fontSize: "14px" }}>{opt}</label>
              </div>
            ))}
          </div>

          <button type="submit" style={{ width: "100%", padding: "10px", backgroundColor: "#fb3104", color: "#fff", border: "none", borderRadius: "8px", fontWeight: "700", fontSize: "15px", cursor: "pointer" }}>
            Submit Registration
          </button>
          <button type="button" onClick={() => navigate(-1)} style={{ width: "100%", marginTop: "10px", padding: "10px", backgroundColor: "transparent", color: "#888", border: "1px solid #ddd", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: "pointer" }}>
            Back
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegisterGraduation;
